package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_01_18_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As the heroes approach the expected location of the Shard of Concar, they see flashes of lightning in the clouds which seem unnatural. Over the hill they see a castle. Annette says the castle appears to be more of a display of wealth than a defensive structure. Furthermore, the castle appears a bit rundown.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday and Caper take flight and scout from the sky. They don’t see anyone in the upper levels, but they do see lit torches at the lower level and footprints of humanoids. Tuesday is concerned that the wind feels unnatural. They see a newer structure behind the castle. The other heroes approach on foot and also see the torch light and smell food cooking. Tuesday and Caper return. The heroes approach the castle, avoiding multiple pit traps.")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("Falorn and Bigglesworth volunteer to scout as polymorphed scorpions. After about an hour, they return and report that they saw")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A backdoor to the castle")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("5 men with a ‘B’ on their uniform")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("7 beds")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("At the backside of the ruins are new structures")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette asks Dirk to pull the center piece of the Shield of Concar from his bag.  The magic casters confirm that the missing piece is nearby in the 1st or 2nd level of the castle.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes sneak into the back door on the north side. Tuesday flies and see 3 people in a room. Caper tries to fool them, while the other heroes sneak by. Annette walks south into a room with 2 people, one of which yells for help. Goram and Bigglesworth rush to Annette’s aid.")
    }
}
